import React from 'react';
import { Link } from 'react-router-dom';
import './ContentCard.css';

// One card for locations, compartments and items. Normally the whole card is a
// link to `to`; editing happens on the page being viewed, not from the card.
// While moving things (`selectable`) it becomes a checkbox row instead.
function ContentCard({ to, image, imageMimeType, imageUrl, placeholder, title, subtitle, meta, selectable, selected, onToggle }) {
  const body = (
    <>
      {selectable && (
        <input
          type="checkbox"
          className="content-card-check"
          checked={!!selected}
          onChange={onToggle}
          aria-label={`Select ${title}`}
        />
      )}
      {image || imageUrl ? (
        <img
          src={imageUrl || `data:${imageMimeType};base64,${image}`}
          alt=""
          loading="lazy"
          className="content-card-thumb"
        />
      ) : (
        <div className="content-card-thumb content-card-placeholder" aria-hidden="true">
          {placeholder}
        </div>
      )}
      <div className="content-card-text">
        <span className="content-card-title">{title}</span>
        {subtitle && <span className="content-card-subtitle">{subtitle}</span>}
        {meta && <span className="content-card-meta">{meta}</span>}
      </div>
      {!selectable && <span className="content-card-chevron" aria-hidden="true">›</span>}
    </>
  );

  return (
    <div className={`content-card${selected ? ' content-card-selected' : ''}`}>
      {selectable ? (
        <label className="content-card-main">{body}</label>
      ) : (
        <Link to={to} className="content-card-main">{body}</Link>
      )}
    </div>
  );
}

export default ContentCard;
